<template>
  <div>
    <p>日均提现折线图</p>
    <div id="withdrawal" :style="{width: '90%', height: '300px'}" />
  </div>
</template>
<script>
import Vue from 'vue'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
export default {
  name: 'Hello',
  props: ["message8"],
  data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  watch: {
    message8: function(newVal, oldVal) {
      let arr = [];
      let sum = [];
      newVal.map(function(value, index) {
        arr.push(value.dateTime)
        sum.push(value.total)
      });
      this.drawLine(arr,sum);
    }
  },
  methods: {
    drawLine(a,s) {
      // 基于准备好的dom，初始化echarts实例
      const myChart = this.$echarts.init(document.getElementById('withdrawal'))
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['提现']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: a
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '提现',
            type: 'line',
            stack: '总量',
            data: s
          }
        ]
      })
    }
  }
}
</script>
